<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import { useAuthStore } from '~/stores/auth.store';
import { useSiteStore } from '~/stores/site.store';
import { unlockBodyScroll } from '~/utilities/ui-utilities';
import { XMarkIcon } from '@heroicons/vue/24/outline';
import UserBalances from '~/components/user/user-balances.vue';

const emits = defineEmits<{
  (e: 'toggleMenu'): void;
}>();

const auth = useAuthStore();
const settings = useSiteStore();
const route = useRoute();
</script>

<template>
  <div class="bg-layer p-4 w-full">
    <div class="flex gap-1">
      <div v-if="!auth.isLoggedIn" class="flex gap-1">
        <Button
          element-name="hamburger-menu-login"
          type="tertiary-alternative"
          @click="[
            settings.activateModal('login'),
            emits('toggleMenu'),
            unlockBodyScroll(),
          ]"
        >
          {{ $t('login') }}
        </Button>
        <Button
          element-name="hamburger-menu-register"
          @click="[
            settings.activateModal('register'),
            emits('toggleMenu'),
            unlockBodyScroll(),
          ]"
        >
          {{ $t('jpc-register') }}
        </Button>
      </div>
      <div v-else class="flex flex-col flex-1 text-xs text-base-priority">
        <div class="truncate">
          {{ $t('welcome') }},
          <!-- prettier-ignore -->
          <strong>
            <!-- If first and last name exist display else display fallback -->
            {{
              auth.currentUser?.firstname ?? $t('user')
            }}
          </strong>
        </div>
        <div class="truncate">
          {{ $t('acc-number') }}:
          <strong>
            {{ auth.currentUser?.primaryMobileNumber?.mobileNumber }}
          </strong>
        </div>
      </div>
      <div class="flex gap-2 ml-auto">
        <UserInterfaceGenericThemeToggle />
        <Button
          element-name="hamburger-menu-close"
          type="tertiary-alternative"
          shape="square"
          class=""
          @click="emits('toggleMenu')"
        >
          <XMarkIcon />
        </Button>
      </div>
    </div>
    <UserBalances
      v-if="auth.isLoggedIn && !route.params?.game"
      class="mt-3 w-full !justify-start"
      display-balance-toggle
      display-cash-balance
      display-bonus-balance
      display-rewards-balance
      display-deposit-button
      deposit-button-style="full"
      deposit-button-fallback="text"
      stretch
      :display-truncated-balance="$enabled('website.truncatecurrency')"
      @open-deposit="emits('toggleMenu')"
    />
  </div>
</template>

<style scoped lang="scss"></style>
